import { setSearchTerm } from "../countriesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useCountrySearch = () => useSearch(s => s.data.listing.countries.searchTerm, setSearchTerm);
